import { getCreatorApiUrl } from '@client/components/api-urls';
import { httpClient } from './api';

type EmailAvailabilityResponse = {
  isAvailable: boolean;
};

export const checkEmailAvailability = async (
  email: string,
): Promise<boolean> => {
  const response = await httpClient.get<EmailAvailabilityResponse>(
    getCreatorApiUrl('/availability'),
    { params: { email } },
  );
  return response.data.isAvailable;
};

type SsoLoginRequest = {
  provider: 'google' | 'apple';
  idToken: string;
};

type SsoRegisterRequest = {
  provider: 'google' | 'apple';
  idToken: string;
  firstName?: string;
  lastName?: string;
  instagram?: string;
  tiktok?: string;
  youtube?: string;
  mobilePhoneNumber?: string;
};

export const ssoLogin = async (request: SsoLoginRequest) => {
  const response = await httpClient.post(
    getCreatorApiUrl('/auth/sso/login'),
    request,
  );
  return response.data;
};

export const ssoRegister = async (request: SsoRegisterRequest) => {
  const response = await httpClient.post(
    getCreatorApiUrl('/auth/sso/register'),
    request,
  );
  return response.data;
};

type SsoRegisterIncompleteRequest = {
  provider: 'google' | 'apple';
  idToken: string;
  firstName?: string;
  lastName?: string;
};

export const ssoRegisterIncomplete = async (
  request: SsoRegisterIncompleteRequest,
) => {
  const response = await httpClient.post(
    getCreatorApiUrl('/auth/sso/register?incomplete=true'),
    request,
  );
  return response.data;
};

type SsoDisconnectRequest = {
  provider: 'google' | 'apple';
};

type SsoConnectRequest = {
  provider: 'google' | 'apple';
  idToken: string;
};

export const ssoConnect = async (request: SsoConnectRequest) => {
  const response = await httpClient.post(
    getCreatorApiUrl('/auth/sso/connect'),
    request,
  );
  return response.data;
};

export const ssoDisconnect = async (request: SsoDisconnectRequest) => {
  const response = await httpClient.post(
    getCreatorApiUrl('/auth/sso/disconnect'),
    request,
  );
  return response.data;
};
